export default "__VITE_ASSET__BBpn_B2J__"